/**
 * Vibrant Intelligence scope (VP-18687).
 *
 * The Vibrant Intelligence project was stopped; the Clinical Calendar is the
 * only part still in use. With CLINICAL_CALENDAR_ONLY on, the other VI pages
 * are hidden from the navbar, unreachable by URL (redirected to the calendar
 * by the router guard), and their login-time backend calls are skipped. The
 * pages themselves are kept intact — flip the flag to bring them back.
 */

export const CLINICAL_CALENDAR_ONLY = true;

export const CLINICAL_CALENDAR_HOME = '/my-calendar';

// Route prefixes for the retired VI pages.
// - /encounter-notes stays reachable: the calendar's "Create Encounter Notes"
//   button opens it in a new tab.
const HIDDEN_PATH_PREFIXES = ['/my-patients', '/my-workbench', '/my-practice'];

// Kept reachable under a hidden prefix: va-portal embeds practice-setting as its
// Settings page, and it is still entered directly for dev purposes.
const ALLOWED_PATH_PREFIXES = ['/my-practice/practice-setting'];

function matchesPrefix(path, prefix) {
  return path === prefix || path.startsWith(`${prefix}/`);
}

/**
 * @param {{ path: string, query?: Record<string, any> }} route
 * @returns {boolean} true when the route belongs to a hidden VI page.
 */
export function isHiddenViRoute(route) {
  if (!CLINICAL_CALENDAR_ONLY || !route || !route.path) return false;
  if (ALLOWED_PATH_PREFIXES.some((prefix) => matchesPrefix(route.path, prefix))) return false;
  return HIDDEN_PATH_PREFIXES.some((prefix) => matchesPrefix(route.path, prefix));
}
